var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip0_3147_43624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6667 26.6673H53.3333C54.0406 26.6673 54.7189 26.9483 55.219 27.4484C55.7191 27.9485 56 28.6267 56 29.334V56.0007C56 56.7079 55.7191 57.3862 55.219 57.8863C54.7189 58.3864 54.0406 58.6673 53.3333 58.6673H10.6667C9.95942 58.6673 9.28115 58.3864 8.78105 57.8863C8.28095 57.3862 8 56.7079 8 56.0007V29.334C8 28.6267 8.28095 27.9485 8.78105 27.4484C9.28115 26.9483 9.95942 26.6673 10.6667 26.6673H13.3333V24.0007C13.3333 21.5493 13.8162 19.122 14.7542 16.8572C15.6923 14.5925 17.0673 12.5347 18.8007 10.8013C20.534 9.06796 22.5918 7.69299 24.8566 6.7549C27.1213 5.81681 29.5487 5.33398 32 5.33398C34.4513 5.33398 36.8787 5.81681 39.1434 6.7549C41.4082 7.69299 43.466 9.06796 45.1993 10.8013C46.9327 12.5347 48.3077 14.5925 49.2458 16.8572C50.1838 19.122 50.6667 21.5493 50.6667 24.0007V26.6673ZM13.3333 32.0007V53.334H50.6667V32.0007H13.3333ZM29.3333 37.334H34.6667V48.0007H29.3333V37.334ZM45.3333 26.6673V24.0007C45.3333 20.4644 43.9286 17.073 41.4281 14.5726C38.9276 12.0721 35.5362 10.6673 32 10.6673C28.4638 10.6673 25.0724 12.0721 22.5719 14.5726C20.0714 17.073 18.6667 20.4644 18.6667 24.0007V26.6673H45.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3147_43624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.bce04db3c9f29d0b4c6494b842cdd359.svg";
export { ForwardRef as ReactComponent };